import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../generic-components/Button';
import { useStore } from '../../../store';
import {
  LEGAL_DOC_PRIVACY_POLICY,
  LEGAL_DOC_TERMS_AND_CONDITIONS_CHOICE,
  LEGAL_DOC_TERMS_AND_CONDITIONS_SUNRISE,
  LEGAL_DOC_TERMS_OF_USE,
} from '../../../constants/general';
import { BANK_DEFINITION_TYPES } from '../../../types';

export const AccountSettingsLegalDocs = () => {
  const getPrimaryAccount = useStore((state) => state.getPrimaryAccount);
  const { t } = useTranslation();
  const linkStyle = 'font-metricR text-[16px] text-bw07 hover:text-bw08 hover:underline text-left';
  const {
    bankInfo: { bank },
  } = getPrimaryAccount();
  const getTermsAndConditionsLink = () => {
    switch (bank) {
      case BANK_DEFINITION_TYPES.CHOICE:
        return LEGAL_DOC_TERMS_AND_CONDITIONS_CHOICE;
      case BANK_DEFINITION_TYPES.CHOICE_TO_SUNRISE:
        return LEGAL_DOC_TERMS_AND_CONDITIONS_CHOICE;
      case BANK_DEFINITION_TYPES.SUNRISE:
        return LEGAL_DOC_TERMS_AND_CONDITIONS_SUNRISE;
      default:
        return '';
    }
  };
  const navigateToTermsOfUse = () => {
    window.open(LEGAL_DOC_TERMS_OF_USE, '_blank');
  };
  const navigateToTermsAndConditions = () => {
    window.open(getTermsAndConditionsLink(), '_blank');
  };
  const navigateToPrivacyPolicy = () => {
    window.open(LEGAL_DOC_PRIVACY_POLICY, '_blank');
  };
  return (
    <div className='mt-[32px]'>
      <p className='font-metricRMedium text-[16px] text-bw08'>
        {t('LEGAL_DOCS.TITLE')}
      </p>

      <div className='overflow-hidden transition-all'>
        <div className='flex flex-col gap-[10px] pt-[10px] w-fit'>
          <Button
            title={t('LEGAL_DOCS.TERMS_OF_USE')}
            id='terms-of-use-button'
            className={linkStyle}
            onClick={navigateToTermsOfUse}
          />
          <Button
            title={t('LEGAL_DOCS.PRIVACY_POLICY')}
            id='privacy-policy-button'
            className={linkStyle}
            onClick={navigateToPrivacyPolicy}
          />
          <Button
            title={t('LEGAL_DOCS.TERMS_AND_CONDITIONS')}
            id='terms-and-conditions-button'
            className={linkStyle}
            onClick={navigateToTermsAndConditions}
          />
        </div>
      </div>
    </div>
  );
};
